<script>
import { params } from '@roxi/routify'
</script>

<pre>{JSON.stringify($params, null, 2)}</pre>
